<template>
  <div class="onlineCourse">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>远程医疗</el-breadcrumb-item>
          <el-breadcrumb-item>视频分类</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane :label="item.text"
                     :name="item.value"
                     v-for="(item, v) in titleData"
                     :key="item.value">
          <div class="table-content">
            <div class="tool-bar">
              <span>关键字：</span>
              <el-input v-model="keyword"
                        size="small"
                        placeholder="请输入"
                        width="264"
                        class="key-word"></el-input>
              <el-button type="primary"
                         size="small"
                         @click="search"
                         v-if="isCompleted && isShowButton('查询')">查询</el-button>
              <el-button size="small"
                         @click="reset"
                         v-if="isCompleted && isShowButton('重置')">重置</el-button>
              <el-button size="small"
                         type="primary"
                         @click="handleDialogShow"
                         v-if="isCompleted && isShowButton('课程添加')">课程添加</el-button>
            </div>
            <div class="course-list">
              <div class="course-content">
                <div class="course-item"
                     v-for="(courseItem, index) in  v === 0 ? courseList : arr "
                     :key="index">
                  <div class="img">
                    <router-link
                                 :to="{path: '/vediolist', query: {courseId: courseItem.id, menuId: menuId}}">
                      <img :src="courseItem.picture"
                           alt="">
                    </router-link>
                      <!-- <el-button icon="el-icon-more"
                                 @click="more(index)"
                                 type="text"
                                 style="height:30px;"
                                 v-if="courseItem.release.key == userId"></el-button> -->
                     
                      
                  </div>
                  <div class="info">
                    <!-- <h4>
                      <router-link
                                   :to="{path: '/vediolist', query: {courseId: courseItem.id, menuId: menuId}}">
                        {{courseItem.courseName}}</router-link>
                    </h4> -->
                    <!-- <p style="margin-top:5px;"> <strong>讲师:</strong> {{courseItem.lecture.value}}</p> -->
                    <p style="margin-top:5px;"> <strong>课程名称:</strong>
                      {{courseItem.courseName}}
                    </p>
                    <div class="tips">
                      <!-- <i>发布时间: {{courseItem.createdTime}}</i> -->
                      <i>内容描述: {{courseItem.describe}}</i>
                    </div>
                    
                        <el-button style="cursor:pointer;float: left; padding: 5px" type="danger"
                           @click="delCourse(courseItem.id, index)">删除</el-button>
                           <el-button style="cursor:pointer;float: right; padding: 5px" type="success"
                           @click="editcourse(courseItem.id, index)">编辑</el-button>
                  </div>
                    
                </div>

              </div>
            </div>
            <!-- 分页 -->
            <el-pagination background
                           :total="total"
                           layout="total, sizes, prev, pager, next, jumper"
                           @size-change='changePageSize'
                           @current-change='changeCurrentPage'
                           :current-page.sync='currentPage'
                           :page-sizes='[12, 24, 36]'
                           :page-size='pageSize'>
            </el-pagination>
          </div>

        </el-tab-pane>

      </el-tabs>
      <el-dialog :title="modalName"
                 :visible.sync="dialogShow">
        <el-form :inline="true"
                 :rules="formRules"
                 :model="ruleForm"
                 ref="ruleForm">
          <el-row>
            <el-col :span="11"
                    :offset="2">
              <el-form-item label="课程名称:"
                            prop="courseName">
                <el-input v-model="ruleForm.courseName"
                          placeholder="请输入"
                          size="mini"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="11">
            <el-form-item label="讲课人:" prop="lecturer">
              <el-input v-model="ruleForm.lecturer" placeholder="请输入" size="mini"></el-input>
            </el-form-item>
          </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="11"
                    :offset="2">
              <el-form-item label="课程分类:"
                            prop="sortingClass">
                <el-select v-model="ruleForm.sortingClass"
                           placeholder="请选择课程分类"
                           >
                  <el-option :label="item.text"
                             v-for="item in educationData"
                             :key="item.value"
                             :value="item.text"></el-option>

                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20"
                    :offset="2">
              <div class="editor">
                <el-form-item label="课程描述:"
                              prop="describe">
                  <el-input rows="5"
                            type="textarea"
                            v-model="ruleForm.describe"
                            placeholder="请输入"
                            size="mini"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <!-- 编辑视频封面 -->
          <el-row>
            <el-col :span="20"
                    :offset="2">
              <el-form-item label="视频封面:" prop="editImg" ref="editImg"  v-if="modalName == '编辑课程'">
                <el-upload class="upload-demo"
                           drag
                           action="/api/Education/AddEducationInfo"
                           :auto-upload="false"
                           :show-file-list="true"
                           accept=".png,.jpg,.bmp,.mp4"
                           ref="imgEditUpload"
                           :limit="1"
                            :file-list="ruleForm.picture"
                           :before-upload="imgEditBeforeUpload"
                           :on-change="editChangeImg"
                           :on-remove="editRemoveFile">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将图片文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip"
                       slot="tip">只能上传jpg,png,bmp文件，且大小不超过20M(此文件为视频封面)</div>
                </el-upload>
                
              </el-form-item>
                <!-- 编辑视频 -->
              <el-form-item label="上传视频：" prop="editVideoUrl"  v-if="modalName == '编辑课程'"
                            >
                <el-upload class="avatar-uploader"
                           action="http://192.168.199.122:5010/api/Education/AddEducationInfo"
                           :show-file-list="true"
                           :limit="1"
                           ref="videoEdit"
                            :file-list="ruleForm.videosFileUrl"
                           :on-success="editAvatarSuccess"
                           :before-upload="beforeUpload"
                           :on-remove="handleRemove"
                          >
                  <i class="el-icon-plus avatar-uploader-icon" />

                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 视频封面上传 -->
          <el-row v-if="modalName == '添加课程'">
            <el-col :span="11"
                    :offset="2">
              <el-form-item label="视频封面:"
                            prop="uploadImg">
                <el-upload action="/api/Education/AddEducationInfo"
                           list-type="picture-card"
                           :auto-upload="false"
                           accept=".png,.jpg,.bmp,.mp4"
                           ref="imgupload"
                           :limit="1"
                           :before-upload="imgBeforeUpload"
                           :on-change="addChangeImg"
                           :on-remove="addRemoveFile"> 
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <!-- 上传视频 -->
              <el-form-item label="上传视频："
                            prop="uploadVideoUrl">
                <el-upload class="avatar-uploader"
                           action="http://192.168.199.122:5010/api/Education/AddEducationInfo"
                           :show-file-list="true"
                           :limit="1"
                           ref="videoUpload"
                           :on-success="handleAvatarSuccess"
                           :before-upload="beforeAvatarUpload"
                           :on-remove="editRemove"
                          >
                  <i class="el-icon-plus avatar-uploader-icon" />

                </el-upload>
              </el-form-item>

            </el-col>
          </el-row>

        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="dialogShow = false">取 消</el-button>
          <el-button type="primary"
                     @click="dialogShow = false, handleSubmit('ruleForm')">确 定</el-button>
        </span>
      </el-dialog>
    </div>

  </div>
</template>
<script>
import Editor from './editor'
import isShowButton from '@/mixins'
export default {
  mixins: [isShowButton],
  components: {
    Editor
  },
  data() {
    return {
      titleData: [],
      educationData: [],
      activeName: "0",
      upToken: localStorage.getItem('token'),
      uploadAddress: '/api/Education/AddEducationInfo',// 视频
      videoFileList: [],
      isCompleted: false, //获取按钮权限的请求是否完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,
      userId: localStorage.getItem('UserId'),
      addImgSrc: '',
      addImgDialog: false,
      isUpload: false,  //false表示不上传封面文件
      editImgIsUpload: false,
      modalName: '',
      vedioName: '',
      vedioDialog: false,
      keyword: '',
      dialogShow: false,
      lecturerList: [],
      ruleForm: {
        courseName: '',
        lecturer: '',
        describe: '',
        isShowMore: false,
        sortingClass: '',
        uploadVideoUrl: '',
        uploadImg: '',
        editImg: '',
        editVideoUrl: ''

      },
      formRules: {
        courseName: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
          { max: 30, message: '长度最多为30个字符', trigger: 'blur' }
        ],
        lecturer: [
          { required: true, message: '请输入讲师名称', trigger: 'blur' },
          { max: 30, message: '长度最多为5个字符', trigger: 'blur' }
        ],
        describe: [
          { required: true, message: '请输入课程描述', trigger: 'blur' },
          { max: 300, message: '长度最多为300个字符', trigger: 'blur' }
        ],

        sortingClass: [
          { required: true, message: '请选择课程分类', trigger: 'blur' },
        ],
          uploadVideoUrl: [
          { required: true, message: '请添加视频', trigger: 'blur' }
        ],
        //   editVideoUrl: [
        //   { required: true, message: '请添加视频', trigger: 'blur' }
        // ],
        //   editImg: [
        //   { required: true, message: '请添加封面', trigger: 'blur' }
        // ],
         uploadImg: [
          { required: true, message: '请添加封面', trigger: 'blur' }
        ]
      },
      currentPage: 1,
      pageSize: 12,
      totalCache: 0,
      courseList: [],
      courseId: '',
      imgFileList: [],
      vedioLength: '',
      // baseUrl: 'http://39.96.6.188:8005/', //线上地址
      // baseUrl: 'http://192.168.199.193:3607/',
      baseUrl: 'http://192.168.199.122:5010/', //图片封面地址
      userName: localStorage.getItem('userName'),
      videoFile: null,
      editVideo: null,
      imgFile: null,
      arr: [],
      tabIndex: null,
      index: ''
    }
  },
  created() {
    this.getBtnRole()
    // console.log(this.userId)
    this.OnlineCourses()

  },
  mounted() {
    this.getAllOnlineCourse(1, 12)
  },
  computed: {
    total() {
      if (this.tabIndex == 1) {
        return parseInt(this.arr.length)
      } else if (this.tabIndex == 2) {
        return parseInt(this.arr.length)
      } else if (this.tabIndex == 3) {
        return parseInt(this.arr.length)
      } else if (this.tabIndex == 4) {
        return parseInt(this.arr.length)
      } else if (this.tabIndex == 5) {
        return parseInt(this.arr.length)
      } else {
        return parseInt(this.totalCache)
      }

    }
  },
  methods: {
    handleSuccess(res, file) {
      // console.log(res, file)
    },
    handleClick(tab, event) {
      this.tabIndex = tab.index
      this.arr = this.courseList.filter(v => {
        if (tab.index + "" === "1") {
          return v.sortingClass === "病案讨论"
        } else if (tab.index + "" === "2") {
          return v.sortingClass === "呼吸治疗选修课"
        } else if (tab.index + "" === "3") {
          return v.sortingClass === "住院医师培训"
        } else if (tab.index + "" === "4") {
          return v.sortingClass === "科研分享"
        } else if (tab.index + "" === "5") {
          return v.sortingClass === "重症护理晚课"
        } else {
          return v.sortingClass
        }

      })
    },
    //视频分类
    OnlineCourses() {
      this.Axios.get('/api/Education/GetDictionary?mark=OnlineCourses').then(res => {
        this.titleData = JSON.parse(JSON.stringify(res.data.arry))
        this.titleData.unshift({ index: "0", text: "全部", value: "0" })
        this.educationData = res.data.arry
      })
    },
    // 视频上传成功钩子函数
    handleAvatarSuccess(res, file) {
      // uploadVideoUrl = res.keyword
      // console.log(res,file)
      this.ruleForm.uploadVideoUrl = file

      this.$message.success('上传成功')
    },
    // 视频上传前钩子函数
    beforeAvatarUpload(file) {
      // console.log(file)
      this.videoFile = file
      const isRightType =
        file.type === 'video/mp4' ||
        file.type === 'video/avi' ||
        file.type === 'video/x-ms-wmv' ||
        file.type === 'video/flv'
      const isLt800M = file.size / 1024 / 1024 < 800

      if (!isLt800M) {
        this.$message.error('暂不支持上传800M大小以上的视频')
      }

      if (!isRightType) {
        this.$message.error('请上传正确格式的视频文件')
      }

      return isLt800M && isRightType
    },

    editAvatarSuccess(res,file) {
      // console.log(res, file)
     

    },

    beforeUpload(file) {

       this.editVideo = file
      const isRightType =
        file.type === 'video/mp4' ||
        file.type === 'video/avi' ||
        file.type === 'video/x-ms-wmv' ||
        file.type === 'video/flv'
      const isLt800M = file.size / 1024 / 1024 < 800

      if (!isLt800M) {
        this.$message.error('暂不支持上传800M大小以上的视频')
      }

      if (!isRightType) {
        this.$message.error('请上传正确格式的视频文件')
      }

      return isLt800M && isRightType
    },
    // 移除当前视频
    handleRemove(file, fileList) {
      // console.log(file, fileList)
      this.ruleForm.editVideoUrl = ''
      // this.uploadVideoUrl = ''
      // this.videoFileList = []
    },
    editRemove(file,fileList) {
      this.ruleForm.uploadVideoUrl = ''
    },
    // 点击 ...
    more(index) {
      if (!this.courseList[index].isShowMore) {
        this.$set(this.courseList[index], 'isShowMore', true)
      } else {
        this.$set(this.courseList[index], 'isShowMore', false)
      }
      // 阻止点击网页出现蓝色背景
      document.onselectstart = new Function("return false");
    },
    // 点击课程添加按钮
    handleDialogShow() {
      this.modalName = '添加课程'
      this.dialogShow = true
      this.ruleForm.courseName = '',
        this.ruleForm.describe = ''
        this.ruleForm.sortingClass = ''
        // this.$refs.videoUpload.clearFiles()
        // this.$refs.imgEditUpload.clearFiles()
        // this.$refs.videoEdit.clearFiles()
        // this.$refs.imgEditUpload.clearFiles()
      // this.$refs.ruleForm.validateField()

      // this.ruleForm.lecturer = ''
    },
    // 点击编辑课程按钮
    editcourse(id, index) {
      this.modalName = '编辑课程'
      this.dialogShow = true
      this.$set(this.courseList[index], 'isShowMore', false)
      this.Axios.get('/api/Education/GetEducationInfo?id=' + id).then(res => {
        let data = res.data
        if (data.status === 100) {
          this.ruleForm = data.data
          this.ruleForm.videosFileUrl = [this.ruleForm.videosFileUrl]
          this.ruleForm.picture = [this.ruleForm.picture]
              this.ruleForm.videosFileUrl = this.ruleForm.videosFileUrl.map(item => {
             return { name: item.substr(35), url: this.baseUrl + item}
          })
           this.ruleForm.picture = this.ruleForm.picture.map(item => {
             return { name: item.substr(35), url: this.baseUrl + item}
          })
        
          console.log(this.ruleForm)
          const info = data.data
          // this.ruleForm.lecturer = info.lecture.value
        } else {
          this.$message({
            showClose: true,
            message: '网络错误,请联系管理员!',
            type: 'error'
          })
        }
      })
    },
    // 添加课程时 更改封面文件
    addChangeImg(file, fileList) {
      this.ruleForm.uploadImg = file

      this.addImgSrc = file.url
      if (fileList.length > 0) {
        this.isUpload = true
      } else {
        this.isUpload = false
      }
    },
    addRemoveFile(file, fileList) {
      // console.log('移除', fileList)
      this.ruleForm.uploadImg = ''

      if (fileList.length > 0) {
        this.isUpload = true
      } else {
        this.isUpload = false
      }
    },
    editChangeImg(file, fileList) {
      this.ruleForm.editImg = file
      // console.log(file)
      if (fileList.length > 0) {
        this.editImgIsUpload = true

      } else {
        this.editImgIsUpload = false
      }
    },
    editRemoveFile(file, fileList) {
      this.ruleForm.editImg = ''

      if (fileList.length > 0) {
        this.editImgIsUpload = true
      } else {
        this.editImgIsUpload = false
      }
    },
    // 新增课程 (上传视频封面)
    imgBeforeUpload(file) {
     
       let fd = new FormData()
              fd.append('files', file)
              fd.append('videoFile', this.videoFile)
              this.Axios.post('/api/Education/AddEducationInfo?courseName=' + this.ruleForm.courseName + '&describe=' + this.ruleForm.describe + '&sortingClass=' + this.ruleForm.sortingClass + '&userID=' + this.userName, fd).then(res => {
                const data = res.data

                if (data.status === 100) {
                  this.$message({
                    showClose: true,
                    message: '添加成功!',
                    type: 'success'
                  })
                  // this.isUpload = false
                  this.getAllOnlineCourse(1, 12)
                } else {
                  // this.isUpload = false
                  this.$message({
                    showClose: true,
                    message: '网络错误,请联系管理员!',
                    type: 'success'
                  })
                }
              })
              return false
      // this.imgFile = file
    },
    // 新增课程(不上传视频封面)
    doAddSave() {
      this.Axios.post('/api/Education/AddEducationInfo?courseName=' + this.ruleForm.courseName + '&describe=' + this.ruleForm.describe + '&userID=' + this.ruleForm.lecturer + '&sortingClass=' + this.ruleForm.sortingClass).then(res => {
        const data = res.data
        if (data.status === 100) {
          this.$message({
            showClose: true,
            message: '添加成功!',
            type: 'success'
          })
          // this.isUpload = false
          this.getAllOnlineCourse(1, 12)
        } else {
          // this.isUpload = false
          this.$message({
            showClose: true,
            message: '网络错误,请联系管理员!',
            type: 'success'
          })
        }
      })
    },
    // 编辑课程 (上传视频封面)
    imgEditBeforeUpload(file) {
      // this.editImgIsUpload = true
       if(!this.ruleForm.videosFileUrl[0].name) {
         let fd = new FormData()
      fd.append('file', file)
      fd.append('videoFile', this.editVideo)
      // console.log(id)
      this.Axios.put('/api/Education/UpdateEducationInfo?courseName=' + this.ruleForm.courseName + '&describe=' + this.ruleForm.describe + '&sortingClass=' + this.ruleForm.sortingClass + '&id=' + this.ruleForm.id, fd).then(res => {
        const data = res.data
        if (data.status === 100) {
          this.$message({
            showClose: true,
            message: '修改成功!',
            type: 'success'
          })
          // this.editImgIsUpload = false
          this.getAllOnlineCourse(1, 12)
        } else {
          // this.editImgIsUpload = false
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'success'
          })
        }
      })
      }
     
      return false
    },
    // 编辑课程 (不上传视频封面)
    doEditSave() {
          let fd = new FormData()
      fd.append('videoFile', this.editVideo)
      this.Axios.put('/api/Education/UpdateEducationInfo?courseName=' + this.ruleForm.courseName + '&describe=' + this.ruleForm.describe + '&sortingClass=' + this.ruleForm.sortingClass  + '&id=' + this.ruleForm.id + '&userID=' + this.ruleForm.lecturer, fd).then(res => {
        const data = res.data
        if (data.status === 100) {
          this.$message({
            showClose: true,
            message: '修改成功!',
            type: 'success'
          })
          // this.editImgIsUpload = false
          this.getAllOnlineCourse(1, 12)
        } else {
          // this.editImgIsUpload = false
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'success'
          })
        }
      })
    
    },
   
    // 执行添加 / 修改课程的操作
    handleSubmit(formName) {



      this.$refs[formName].validate((valid) => {
        //  this.ruleForm.uploadImg = ''
        //  this.ruleForm.uploadVideoUrl = ''
        if (valid) {
          //执行添加的操作
           
          if (this.modalName === '添加课程') {
            if (this.isUpload) {
              // 要上传课程封面和课程内容
              // this.imgBeforeUpload()
              this.$refs.imgupload.submit()
            } else {
              // 不上传课程封面只上传课程内容
              // this.doAddSave()
            }
          }
          // 执行修改的操作
          else {
            if (!this.editImgIsUpload) {
              // 不上传课程封面只上传课内容
              this.doEditSave()
            } else {
              // 要上传课程封面和课程内容
              this.$refs.imgEditUpload.submit()
              
            }
          }
        } else {
          this.$message({
            showClose: true,
            message: '请把数据补充完整!',
            type: 'error'
          })
          this.dialogShow = true
          return false
        }
      })
    },
    //  删除课程
    delCourse(courseId, index) {
      this.$set(this.courseList[index], 'isShowMore', false)
      console.log(courseId)
      this.Axios.delete('/api/Education/DeleteEducationInfo?id=' + courseId).then(res => {
        const data = res.data
        if (data.status === 100) {
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success'
          })
          this.getAllOnlineCourse(this.currentPage, this.pageSize)
        } else {
          this.$message({
            showClose: true,
            message: '删除失败!',
            type: 'success'
          })
        }
      })
    },
    // 查询所有课程
    getAllOnlineCourse(currentPage, pageSize, keyword) {
      const params = {
        start: currentPage,
        pagesize: pageSize,
        keyword: keyword
      }
      this.Axios.get('/api/Education/SearchEducation', { params: params }).then(res => {
        const data = res.data
        if (data.status === 100) {
          this.totalCache = data.total
          for (let item of data.data) {
            item.picture = this.baseUrl + item.picture
            item.isShowMore = false
          }
          this.courseList = data.data

        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    changeCurrentPage(currentPage) {
      this.getAllOnlineCourse(currentPage, this.pageSize)
    },
    changePageSize(pageSize) {
      this.getAllOnlineCourse(this.currentPage, pageSize)
    },
    search() {
      this.getAllOnlineCourse(1, 12, this.keyword)
    },
    reset() {
      this.keyword = ''
      this.getAllOnlineCourse(1, 12)
    },
  }
}
</script>

<style scoped lang="less">
/deep/.el-tabs__content {
  background-color: rgb(240, 242, 245);
}
.el-col {
  display: flex;
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .avatar-uploader-icon:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  background-color: #fbfdff;
  border-radius: 6px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.onlineCourse {
  .table-info {
    background-color: rgb(240, 242, 245);
  }
  .breadcrumb {
    overflow: hidden;
    span,
    .el-breadcrumb {
      float: left;
    }
    span {
      font-size: 14px;
      color: #666;
      line-height: 1;
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .status {
        width: 264px;
        margin-right: 40px;
      }
    }
    .course-list {
      margin: 20px 0;
      overflow: hidden;
      .course-content {
        width: 103%;
        .course-item {
          width: 260px;
          height: 290px;
          background: #fff;
          margin: 0 20px 20px 0;
          float: left;
          .img {
            width: 100%;
            height: 173px;
            display: block;
            position: relative;
            .more {
              color: white;
              position: absolute;
              top: -5px;
              right: 10px;
              text-align: right;
              // cursor: pointer;
              .editDel {
                margin-top: 6px;
                font-size: 12px;
                width: 66px;
                text-align: center;
                background: white;
                color: #101010;
                height: 64px;
                line-height: 32px;
                border-radius: 2px;
              }
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          .info {
            box-sizing: border-box;
            height: 105px;
            width: 100%;
            padding: 15px;
            h4 {
              font-size: 16px;
              font-weight: 650;
            }
            p {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.43);
              font-weight: 400;
            }
            .tips {
              margin-top: 10px;
              overflow: hidden;
              i {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.43);
                font-weight: 400;
              }
              .person {
                width: 60px;
                height: 20px;
                position: relative;
                .head {
                  position: absolute;
                  top: 0;
                  width: 20px;
                  height: 18px;
                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
                .head:nth-child(1) {
                  left: 0;
                  z-index: 5;
                }
                .head:nth-child(2) {
                  left: 10px;
                  z-index: 4;
                }
                .head:nth-child(3) {
                  left: 20px;
                  z-index: 3;
                }
                .head:nth-child(4) {
                  left: 30px;
                  z-index: 2;
                }
                .head:nth-child(5) {
                  left: 40px;
                  z-index: 1;
                }
              }
            }
          }
        }
      }
    }
    .el-pagination {
      /deep/ .number,
      /deep/ .btn-prev,
      /deep/ .btn-next {
        background-color: #fff;
        border: 1px solid #d9d9d9;
        width: 32px;
        height: 32px;
      }
    }
  }
  // .editor {
  //   /deep/ .el-textarea__inner {
  //     width: 500px;
  //   }
  // }
  .el-dialog__wrapper {
    .el-row {
      padding: 15px;
      .title {
        text-align: right;
      }
    }
    .full {
      .el-input {
        width: 555px;
      }
    }
    .el-input,
    .el-select {
      width: 206px;
    }
    /deep/ .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /deep/ .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
    /deep/ .el-textarea__inner {
      width: 505px;
      // width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/RemoteMedical/OnlineCourse.vue